"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const namespaces_1 = require("../../namespaces");
const ResourceFilterableCollection_1 = require("./ResourceFilterableCollection");
/**
 * Provides a convenient collection for {@link ICollection}s.
 */
class CollectionsCollection extends ResourceFilterableCollection_1.default {
    /**
     * Initializes a new instance of the {@link CollectionsCollection} class.
     * @param {Iterable<ICollection>} collections Initial collections to add to the collection.
     */
    constructor(collections) {
        super(collections);
    }
    /**
     * Obtains those collections that defines a hydra:manages block matching a given property and object.
     * @param {string} subject Subject to match in the hydra:manages block.
     * @param {string} property Property to match in the hydra:manages block.
     * @returns {CollectionsCollection}
     */
    withMembersInRelationWith(subject, property) {
        let result = this;
        if (typeof property === "string" && property.length > 0 && typeof subject === "string" && subject.length > 0) {
            result = this.where(item => item.manages.where(_ => _.property.iri === property && _.subject.iri === subject).any());
        }
        return result;
    }
    /**
     * Obtains those collections that defines a hydra:manages block matching a given property and object.
     * @param {string} property Property to match in the hydra:manages block.
     * @param {string} object Object to match in the hydra:manages block.
     * @returns {CollectionsCollection}
     */
    withMembersMatching(property, object) {
        let result = this;
        if (typeof property === "string" && property.length > 0 && typeof object === "string" && object.length > 0) {
            result = this.where(item => item.manages.where(_ => _.property.iri === property && _.object.iri === object).any());
        }
        return result;
    }
    /**
     * Obtains those collections that defines a hydra:manages block matching a given type and type IRI.
     * @param {string} type Type to match in the hydra:manages block.
     * @returns {CollectionsCollection}
     */
    withMembersOfType(type) {
        return this.withMembersMatching(namespaces_1.rdf.type, type);
    }
}
exports.default = CollectionsCollection;
//# sourceMappingURL=CollectionsCollection.js.map